// src/stores/authStore.js
import { defineStore } from "pinia";
import { authService } from "@/services/authService";
import { useAppStore } from "@/stores/appStore";

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: !!localStorage.getItem("token"),
  }),

  actions: {
    async login(params) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await authService.signIn(params);

        this.token = response.data.token;
        this.user = response.data.user;
        this.isAuthenticated = true;

        localStorage.setItem("token", this.token);
        localStorage.setItem("user", JSON.stringify(this.user));
        localStorage.setItem("expiresAt", new Date().getTime() + 3600 * 1000);

        //return response;
      } catch (error) {
        console.log(error);
      } finally {
        appStore.setLoading(false);
      }
    },

    logout() {
      this.token = null;
      this.user = null;
      this.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("expiresAt");
    },

    autoLogin() {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const expiresAt = localStorage.getItem("expiresAt");

      if (token && user && expiresAt) {
        const now = new Date().getTime();
        if (now < expiresAt) {
          this.token = token;
          this.user = user;
          this.isAuthenticated = true;
        } else {
          this.logout();
        }
      }
    },
  },
});
